import React from 'react';
import { CancelWithSupport } from '@/components/billing/subscriptions/CancelWithSupport';
import { CANCEL_FLOW_HUMAN_SUPPORT } from '@/config/GrowthBook/constants';

const CancelWithSupportPage = () => (
  <CancelWithSupport
    featureFlag={CANCEL_FLOW_HUMAN_SUPPORT}
    zendeskTag="hgbr_chat_retencao_a_b"
    redirectRoute="cancelSubscription"
  />
);

export default CancelWithSupportPage;
